import {getAvailableNames, getSvg} from '@infomaker/content-icon-pack'
import {useState} from 'react';
import {Toaster, toast} from 'react-hot-toast'

function fallbackCopyTextToClipboard(text) {
  const textArea = document.createElement("textarea");
  textArea.value = text;

  // Avoid scrolling to bottom
  textArea.style.top = "0";
  textArea.style.left = "0";
  textArea.style.position = "fixed";

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    const successful = document.execCommand('copy');
    if (successful) {
      toast.success((t) => <span>Copied <b>{text}</b> to clipboard</span>)
      console.info(`Copied ${text} to clipboad`);
    }
  } catch (err) {
    console.error('Fallback: Oops, unable to copy', err);
  }

  document.body.removeChild(textArea);
}

function copyTextToClipboard(text) {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text);
    return;
  }
  navigator.clipboard.writeText(text).then(function() {
    toast.success((t) => <span>Copied <b>{text}</b> to clipboard</span>)
  }, function(err) {
    console.error('Async: Could not copy text: ', err);
  });
}

function App() {
  const icons = getAvailableNames()
  const [searchQuery, setSearchQuery] = useState('')

  return (
    <>
      <Toaster />
      <header className="h-96 flex items-center justify-center bg-indigo-700 flex-col px-4 lg:pb-20">
        <div className="text-white text-5xl">Naviga Content Icon Pack</div>
        <code className="px-4 py-2 mt-4 text-sm text-indigo-900 bg-indigo-300">Writer version 7.1.0</code>
      </header>
      <div className="max-w-6xl m-auto lg:-mt-20 bg-white rounded-md border border-gray-200">

        <input
          type="search"
          name="search"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="w-full rounded-t-md border-b border-gray-200 px-8 py-4 text-xl focus:outline-none"
          placeholder="Search"
        />
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 overflow-hidden gap-px">
          {icons.filter(icon => icon.includes(searchQuery)).map(name => {
            const svg = getSvg(name)
            return (
              <div className="w-full h-44 flex flex-col items-center justify-center relative hover:bg-indigo-100 hover:text-indigo-700 cursor-pointer" key={name} onClick={() => copyTextToClipboard(name)}>
                <div className="w-8 h-8">
                  <div dangerouslySetInnerHTML={{__html: svg}} />
                </div>
                <div className="text-xs absolute bottom-4 px-4 text-center">{name}</div>
              </div>
            )
          })}
        </div>
      </div>
    </>
  );
}

export default App;
